module.exports = __webpack_public_path__ + "assets/img/tit.f930725e.png";